export default __webpack_public_path__ + "static/media/abhay.427a1fb2.bin";